import React from "react";
import "../../style/news/happyNewYear.css";
import Comment from "../shared/Comment/Comment";
import Footer from "../shared/Footer/Footer";
import Navbar from "../shared/Navbar/Navbar";
import { useEffect } from "react";
import TranslateButton from "../TranslateButton/TranslateButton";

const HappyNewYear = () => {
  useEffect(() => {
    document.title = `Development Concern | Happy New Year`;
  }, []);

  // const shareUrl = "https://developmentconcerncht.org/happy-new-year";

  return (
    <>
      <Navbar />
      {/* <TranslateButton /> */}

      <div className="happy_new_year_section">
        <div className="blog_title">
          <div className="container">
            <h6>
              Happy New Year – Let the Adventure Begin
            </h6>
            <h2>
              Happy New Year – Let the Adventure Begin
            </h2>
            <h3>January 1, 2026</h3>
          </div>
        </div>

        <div className="image_part">
          <div className="header_image"></div>
          {/* Social Share Section Start */}
          {/* <div className="social_share_wrapper">
            <div className="container">
              <div className="social_share_button">
                <FacebookShareButton
                  url={shareUrl}
                  target={"_blank"}
                  quote={"share facebook"}
                  hashtag={"#facebook"}
                >
                  <FacebookIcon size={35} round={true} />
                </FacebookShareButton>
                <TwitterShareButton
                  url={shareUrl}
                  target={"_blank"}
                  quote={"share twitter"}
                  hashtag={"#twitter"}
                >
                  <TwitterIcon size={35} round={true} />
                </TwitterShareButton>
                <LinkedinShareButton
                  url={shareUrl}
                  target={"_blank"}
                  quote={"share linkedin"}
                  hashtag={"#linkedin"}
                >
                  <LinkedinIcon size={35} round={true} />
                </LinkedinShareButton>
              </div>
            </div>
          </div> */}
          {/* Social Share Section End */}
        </div>
        <div className="content_wrapper">
          <div className="container">
            <p className="margin_top">
              The New Year is more than just a change in the calendar—it’s an opportunity to start fresh. Each January opens a new chapter where we can set goals, leave behind mistakes, and embrace growth. It’s the perfect moment to reflect on the past and step into the future with positivity.
            </p>
            <p className="my-4">
              New Year celebrations are filled with fireworks, family gatherings, and heartfelt wishes. But beyond the festivity, it’s also about gratitude. Appreciating the lessons of yesterday and the blessings we already have makes our new journey more meaningful.
            </p>
            <p>
              Every year gives us 365 new chances. By setting clear goals—whether personal growth, career success, or healthier habits—we create direction and purpose. Dreams become achievable when paired with dedication, discipline, and determination.
            </p>
            <p className="mt-4">
              As we welcome 2026, let’s spread kindness, unity, and hope. May this year bring peace to our hearts, prosperity to our homes, and happiness in every step of our journey. A new year is not just about counting days—it’s about making every day count.
            </p>
            <button>
              <a
                href="/all-blogs"
                target={"_blank"}
                id="style-2"
                data-replace="See More Blogs"
              >
                <span>See More Blogs</span>
              </a>
            </button>
          </div>
        </div>
      </div>

      {/* Comment Section */}
      <Comment />
      <Footer />
    </>
  );
};

export default HappyNewYear;
